/* INTEGY V501 — route-scoped responsive image, touch-card, product and cart safety. */
/* ---- consolidated from integy-v484-responsive-safety.js ---- */
/* INTEGY V484 — responsive safety + Shopify-first visible image owner.
   Consolidates the still-needed V481 image/touch/cart safety while removing the
   superseded V481 page-specific rail stabilizer; V484 commerce owner now owns rails.
   Replaces V426 overlay ownership and the V16/V196/V322/V323 mutation-heavy mobile patches. */
(function () {
  'use strict';
  if (window.IntegyV501ResponsiveSafety) return;

  var root = document.documentElement;
  function v626Root(){
    try { var r=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root; if(r) return r.charAt(r.length-1)==='/'?r:r+'/'; } catch(error) {}
    return '/';
  }
  var touchMedia = window.matchMedia ? window.matchMedia('(pointer: coarse), (max-width: 860px)') : null;
  var productCache = Object.create(null);
  var queue = [];
  var activeFetches = 0;
  var maxFetches = 6;
  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;

  function qs(selector, scope) {
    try { return (scope || document).querySelector(selector); } catch (error) { return null; }
  }
  function qsa(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); } catch (error) { return []; }
  }
  function isTouch() { return !!(touchMedia && touchMedia.matches); }
  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent('integy:analytics', { detail: { event: name, data: detail || {} } })); } catch (error) {}
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: 'integy_' + name, integy: detail || {} });
    }
  }

  function updateDeviceClass() {
    root.classList.toggle('integy-v436-touch', isTouch());
    root.classList.toggle('integy-v436-fine', !isTouch());
  }

  /* Mobile filter ownership moved to the V466 controller. */

  /* -------------------------- product image repair ------------------------ */
  function safeImage(value) {
    value = String(value || '').trim();
    if (/^\/\/cdn\.shopify\.com\//i.test(value)) return location.protocol + value;
    if (/^https?:\/\/[^/]*(?:cdn\.shopify\.com|shopifycdn\.com)\//i.test(value)) return value;
    if (/^\/cdn\/shop\//i.test(value)) return value;
    if (/^https:\/\/ssl-firewall-6zh26qy9vm\.integy\.com\/product-images\/[a-z0-9._%+-]+\.(?:avif|webp|jpe?g|png)(?:[?#].*)?$/i.test(value)) return value;
    if (/^https:\/\/(?:www\.)?integy\.com\/product-images\/[a-z0-9._%+-]+\.(?:avif|webp|jpe?g|png)(?:[?#].*)?$/i.test(value)) return value;
    return '';
  }
  function productPath(value) {
    try {
      value = String(value || '').trim();
      var url = /^https?:\/\//i.test(value) ? new URL(value) : new URL(value, location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? v626Root() + 'products/' + match[1] : '';
    } catch (error) { return ''; }
  }
  function loadProduct(path) {
    if (!path) return Promise.resolve(null);
    if (!productCache[path]) {
      productCache[path] = fetch(path + '.js', { credentials: 'same-origin', cache: 'force-cache' })
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .catch(function () { return null; });
    }
    return productCache[path];
  }
  function runQueue() {
    while (activeFetches < maxFetches && queue.length) {
      activeFetches += 1;
      var job = queue.shift();
      job().catch(function () {}).then(function () {
        activeFetches -= 1;
        runQueue();
      });
    }
  }
  function enqueue(job) { queue.push(job); runQueue(); }
  function clearLegacyImageTimer(card) {
    if (!card || !card._integyV467ImageTimer) return;
    window.clearTimeout(card._integyV467ImageTimer);
    card._integyV467ImageTimer = 0;
  }
  function attachImageFallback(card, image, index) {
    if (!card || !image || image.dataset.integyV467FallbackBound === 'true') return;
    image.dataset.integyV467FallbackBound = 'true';
    image.addEventListener('load', function () {
      clearLegacyImageTimer(card);
      card.dataset.integyV436ImageHydrated = 'true';
      card.classList.remove('integy-v467-image-pending', 'integy-v467-image-failed');
    }, { once: true });
    image.addEventListener('error', function () {
      clearLegacyImageTimer(card);
      card.dataset.integyV436ImageHydrated = '';
      card.classList.add('integy-v467-image-failed');
      hydrateCard(card, index, true);
    }, { once: true });
    if (/^https:\/\/ssl-firewall-6zh26qy9vm\.integy\.com\/product-images\//i.test(image.currentSrc || image.src || '')) {
      clearLegacyImageTimer(card);
      card._integyV467ImageTimer = window.setTimeout(function () {
        card._integyV467ImageTimer = 0;
        if (image.complete && image.naturalWidth > 0) return;
        card.dataset.integyV436ImageHydrated = '';
        card.classList.add('integy-v467-image-pending');
        hydrateCard(card, index, true);
      }, 1800);
    }
  }
  function hydrateCard(card, index, force) {
    if (!card) return;
    if (!force && card.dataset.integyV436ImageHydrated === 'true') return;
    var anchor = qs('a[href*="/products/"]', card);
    var path = productPath(anchor && anchor.getAttribute('href'));
    var figure = qs('[data-product-item-image],.productitem--image', card);
    if (!path || !figure) return;
    var current = qs('img', figure);
    var currentUrl = current && (current.currentSrc || current.getAttribute('src'));
    var legacyFirewallImage = /^https:\/\/ssl-firewall-6zh26qy9vm\.integy\.com\/product-images\//i.test(String(currentUrl || ''));
    // V481: on the first visible dynamic cards, prefer Shopify's own product JSON
    // image immediately instead of waiting up to 1.8s for the legacy firewall host.
    // Deeper cards retain the low-request fallback behavior until they are needed.
    if (!force && safeImage(currentUrl) && !(legacyFirewallImage && index < 18)) {
      attachImageFallback(card, current, index);
      card.dataset.integyV436ImageHydrated = 'true';
      return;
    }
    if (legacyFirewallImage && index < 18) force = true;
    if (card.dataset.integyV467HydrationQueued === 'true') return;
    card.dataset.integyV467HydrationQueued = 'true';
    card.classList.add('integy-v467-image-pending');
    enqueue(function () {
      return loadProduct(path).then(function (product) {
        var image = product && (product.featured_image || (product.images && product.images[0]));
        if (image && typeof image === 'object') image = image.src || image.url;
        image = safeImage(image);
        if (!image) {
          card.classList.add('integy-v467-image-failed');
          return;
        }
        var img = current || document.createElement('img');
        img.className = 'productitem--image-primary integy-v436-hydrated-image';
        img.src = image;
        img.alt = (product && product.title) || (anchor && anchor.textContent.trim()) || '';
        img.width = 480;
        img.height = 480;
        img.loading = index < 12 ? 'eager' : 'lazy';
        img.decoding = 'async';
        if (index === 0) img.fetchPriority = 'high';
        attachImageFallback(card, img, index);
        if (!current) { figure.innerHTML = ''; figure.appendChild(img); }
        card.dataset.integyV436ImageHydrated = 'true';
        card.classList.remove('integy-v467-image-pending', 'integy-v467-image-failed');
      }).finally(function () {
        card.dataset.integyV467HydrationQueued = '';
      });
    });
  }
  function hydrateCollectionImages(scope) {
    qsa('.integy-v307-canonical-card,[data-integy-v426-product-url],.integy-v501-related-card,[data-recently-viewed-card].product-recently-viewed-card', scope || document).forEach(hydrateCard);
  }

  /* ------------------------- touch card conversion ------------------------ */
  function ensureTouchCardActions(scope) {
    if (!isTouch()) return;
    qsa('body.template-collection .productgrid--item,body.template-search .productgrid--item', scope || document).forEach(function (card) {
      if (card.dataset.integyV436TouchAction === 'true') return;
      card.dataset.integyV436TouchAction = 'true';
      var existing = qs('.integy-v158-list-link', card);
      if (existing) {
        if (!existing.textContent.trim()) existing.textContent = 'View product';
        return;
      }
      var source = qs('.productitem--title a,a[href*="/products/"]', card);
      var info = qs('.productitem--info', card) || card;
      if (!source || !info) return;
      var link = document.createElement('a');
      link.className = 'integy-v158-list-link integy-v436-touch-view-link';
      link.href = source.href;
      link.textContent = 'View product';
      info.appendChild(link);
    });
  }

  /* V477 owns recently-viewed rendering and sizing. The legacy V436 Flickity
     resize observer was removed to avoid competing height calculations. */

  /* -------------------------- purchase/cart safety ------------------------ */
  function normalizeProductPurchase(scope) {
    qsa('body.template-product .quantity-selector__button--minus', scope || document).forEach(function (button) {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', 'Decrease quantity');
    });
    qsa('body.template-product .quantity-selector__button--plus', scope || document).forEach(function (button) {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', 'Increase quantity');
    });
    qsa('body.template-product .product-form__action-wrapper', scope || document).forEach(function (wrapper) {
      wrapper.classList.add('integy-v436-purchase-ready');
    });
  }
  function normalizeCart(scope) {
    if (!document.body || !document.body.classList.contains('template-cart')) return;
    qsa('.cart-policy-agreement', scope || document).forEach(function (agreement) {
      agreement.hidden = false;
      agreement.removeAttribute('aria-hidden');
    });
    qsa('button[name="checkout"],a[href*="/checkout"]', scope || document).forEach(function (button) {
      button.removeAttribute('aria-disabled');
      button.classList.add('integy-v436-checkout-control');
    });
  }

  function dedupeControls() {
    [
      '[data-productgrid-trigger-filters],.utils-filter-button,.productgrid--sidebar-button',
      '[data-productgrid-trigger-sort-button],.utils-sortby-button'
    ].forEach(function (selector) {
      var controls = qsa(selector).filter(function (element) { return !element.closest('.productgrid--sidebar'); });
      controls.forEach(function (element, index) {
        if (index > 0) { element.hidden = true; element.setAttribute('aria-hidden', 'true'); }
      });
    });
  }

  function observeContainer(container, callback) {
    if (!container || !window.MutationObserver) return;
    if (observed && observed.has(container)) return;
    if (observed) observed.add(container);
    var timer = 0;
    new MutationObserver(function (mutations) {
      if (!mutations.some(function (mutation) { return mutation.addedNodes && mutation.addedNodes.length; })) return;
      clearTimeout(timer);
      timer = window.setTimeout(function () { callback(container); }, 60);
    }).observe(container, { childList: true, subtree: true });
  }



  function normalizeNativeOrderingControls(scope) {
    qsa('body.template-product .quantity-selector__button--minus', scope || document).forEach(function (button) {
      button.setAttribute('aria-label','Decrease quantity'); button.removeAttribute('aria-hidden');
    });
    qsa('body.template-product .quantity-selector__button--plus', scope || document).forEach(function (button) {
      button.setAttribute('aria-label','Increase quantity'); button.removeAttribute('aria-hidden');
    });
    qsa('body.template-product button.product-form--atc-button,body.template-product [data-product-atc],body.template-cart button[name="checkout"],body.template-cart a[href*="/checkout"],.cart-drawer button[name="checkout"]', scope || document).forEach(function (button) {
      button.style.pointerEvents='auto'; button.removeAttribute('aria-hidden');
    });
    qsa('[data-integy-sticky-atc],.integy-mobile-sticky-atc,.integy-v326-sticky-atc,.integy-v370-sticky-atc', scope || document).forEach(function (node) { node.remove(); });
  }

  function refresh(scope) {
    updateDeviceClass();
    dedupeControls();
    hydrateCollectionImages(scope || document);
    ensureTouchCardActions(scope || document);
    normalizeProductPurchase(scope || document);
    normalizeCart(scope || document);
    normalizeNativeOrderingControls(scope || document);
  }
  function boot() {
    refresh(document);
    observeContainer(qs('.productgrid--items,[data-productgrid-items]'), function (container) {
      hydrateCollectionImages(container);
      ensureTouchCardActions(container);
    });
    observeContainer(qs('main'), function (main) {
      hydrateCollectionImages(main);
      normalizeProductPurchase(main);
      normalizeCart(main);
    });
  }

  /* V466 owns filter interactions. V436 retains product/cart analytics and safety only. */
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-quickshop-full],[name="add"],[data-product-atc],[name="checkout"],[data-checkout]') : null;
    if (!target) return;
    if (target.matches('[data-quickshop-full]')) emit('quick_shop_opened', { path: location.pathname });
    else if (target.matches('[name="add"],[data-product-atc]')) emit('add_to_cart', { path: location.pathname });
    else emit('checkout_started', { path: location.pathname });
  }, false);

  function viewportChanged() {
    updateDeviceClass();
    ensureTouchCardActions(document);
  }
  if (touchMedia) {
    if (touchMedia.addEventListener) touchMedia.addEventListener('change', viewportChanged);
    else if (touchMedia.addListener) touchMedia.addListener(viewportChanged);
  }
  window.addEventListener('orientationchange', viewportChanged, { passive: true });
  window.addEventListener('pageshow', viewportChanged, { passive: true });
  document.addEventListener('shopify:section:load', function (event) { refresh(event.target || document); });


  window.IntegyV501ResponsiveSafety = window.IntegyV500ResponsiveSafety = window.IntegyV499ResponsiveSafety = window.IntegyV495ResponsiveSafety = { version: 'V501', hydrateCollectionImages: hydrateCollectionImages, refresh: refresh };

  root.classList.add('integy-v436-mobile-commerce-owner', 'integy-v495-responsive-safety-owner', 'integy-v500-responsive-safety-owner', 'integy-v501-responsive-safety-owner');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
